import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { ContainerSize } from 'src/app/core/models/container-size';
import { ContainerSizeService } from 'src/app/core/services/general/container-size.service';

@Component({
  selector: 'app-container-size-input',
  templateUrl: './container-size-input.component.html',
  styleUrls: ['./container-size-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ContainerSizeInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: ContainerSizeInputComponent,
    },
  ],
})
export class ContainerSizeInputComponent {
  @Input()
  title = "Select Container Size...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public containerSizesList: Array<CustomSelectOption> = [];

  constructor(
    private containerSizeService: ContainerSizeService,
  ) {
    this.containerSizeService
      .all()
      .subscribe((res: Array<ContainerSize>) => {
        this.containerSizesList = res.map((el) => {
          return {
            name: `${el.size}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.containerSizesList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
